// extracted by mini-css-extract-plugin
module.exports = {"fullScreenSpinner":"FullScreenSpinner_fullScreenSpinner__ypoZz"};